import firebase, { usersRef } from "./firebaseconn";

const NEW_USER = "Usuário";

export const getUser = async function(email) {
  try {
    const user = await usersRef.doc(email).get();

    if (!user) return undefined;
    return user.data();
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateUser = async function(email, data) {
  data.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
  try {
    await usersRef.doc(email).update(data);
    return true;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const createUser = async function(
  email,
  data,
  isActive = true,
  isAdmin = false
) {
  data.userName = NEW_USER + "_" + new Date().getTime().toString();

  data.createdAt = firebase.firestore.FieldValue.serverTimestamp();
  data.updatedAt = firebase.firestore.FieldValue.serverTimestamp();
  data.active = isActive;
  data.admin = isAdmin;

  try {
    await usersRef.doc(email).set(data);
    return true;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
